import * as station from '../actions/smartQueryAction'

const initialState = {
    result: [],
    error: undefined,
    status: 0
};

const smartQuery = (state = initialState, action) => {
    switch (action.type) {
        case station.SMART_QUERY_REQUEST:
            return ({
                ...initialState,
                status: 1
            });
        case station.SMART_QUERY_SUCCESS:
            return ({
                ...action.result,
                error: undefined,
                status: 2
            });
        case station.SMART_QUERY_FAILURE:
            return ({
                result: [],
                error: action.error,
                status: 3
            });
        default:
            return state;
    };
}

export default smartQuery;
